import { inject, ComponentEventBus } from "fw";

import { ForgotPasswordForm } from "forms/forgot-password";
import { UserRepository } from "network/user-repository";

@inject
export class ForgotPasswordModal {
    private forgotPasswordForm = new ForgotPasswordForm();
    private loading = false;
    private isDone = false;

    constructor(
        private ceb: ComponentEventBus,
        private userRepo: UserRepository
    ) {}

    private async forgot() {
        this.loading = true;

        try {
            this.forgotPasswordForm.validate();
            await this.userRepo.forgotPassword(this.forgotPasswordForm.EmailAddress);
            this.isDone = true;
        } catch (err) {}

        this.loading = false;
    }

    close() {
        this.ceb.dispatch("close");
    }
}
